export { EvInfoCard } from "./ev-info-card";
